// extracted by mini-css-extract-plugin
module.exports = {"tpbLogo":"ThePrivateBankLogo__tpbLogo___2i5-6","tpbLogoBim":"ThePrivateBankLogo__tpbLogoBim___17QBw","reversed":"ThePrivateBankLogo__reversed___3yz8G"};